module.exports = __webpack_public_path__ + "img/cloud.738a1f6f.png";